/* eslint-disable react-portal/no-react-router-use-navigate */
import { Route, Routes } from 'react-router-dom';
import AuthPanel from './AuthPanel';
import PasswordResetRequest from './PasswordResetRequest';
import PasswordResetWithCode from './PasswordResetWithCode';

export default function PasswordResetPages() {
    return (
        <AuthPanel>
            <Routes>
                <Route path="/" element={<PasswordResetWithCode />} />
                <Route path="/request" element={<PasswordResetRequest />} />
            </Routes>
        </AuthPanel>
    );
}
